import React, { createContext, useContext, useEffect, useState } from "react";
import { translate } from "./i18n";

const IS_DEV = process.env.NODE_ENV !== "production";
const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("to_lang") || "en";
    } catch (err) {
      // Safari Private mode and some embedded browsers throw on localStorage access.
      if (IS_DEV) console.warn("[lang] could not read saved language preference:", err);
      return "en";
    }
  });
  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("to_lang", l);
    } catch (err) {
      if (IS_DEV) console.warn("[lang] could not persist language preference:", err);
    }
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key, params = {}) => translate(key, lang, params);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
